<template>
    <div class="investment-platform">
        <v-container fluid class="investment-container">
            <section class="dashboard-header">
                <div class="dashboard-header__title-group">
                    <div class="dashboard-header__title">
                        <span class="dashboard-header__title-icon" aria-hidden="true">
                            <v-icon color="white" size="32">mdi-trending-up</v-icon>
                        </span>
                        <span class="text-uppercase">Môj dar pre slovensko</span>
                    </div>
                    <div class="dashboard-header__hero-image-wrap">
                        <img
                            :src="headerImageSrc"
                            alt="Rodina pri stole"
                            class="dashboard-header__hero-image"
                        >
                    </div>
                </div>
                <div class="dashboard-header__meta">
                    <div class="dashboard-header__meta-title">Moje základné údaje</div>
                    <div class="dashboard-header__meta-row">
                        <span>Darca</span>
                        <strong>{{ investorDisplayName }}</strong>
                    </div>
                    <div class="dashboard-header__meta-row">
                        <span>Môj stav</span>
                        <v-chip x-small :color="portfolioHealthChip.color" dark>
                            {{ portfolioHealthChip.label }}
                        </v-chip>
                    </div>
                    <div class="dashboard-header__meta-row">
                        <span>Môj podiel na daroch</span>
                        <strong>{{ portfolioParticipationPercentage }} %</strong>
                    </div>
                </div>
            </section>

            <section class="dashboard-overview">
                <v-row>
                    <v-col cols="12" lg="5">
                        <v-card class="overview-card overview-card--investments" elevation="0">
                            <div class="overview-card__title">
                                <v-icon left color="#3650c9">mdi-wallet-outline</v-icon>
                                Moje dary
                            </div>
                            <div class="overview-list">
                                <div class="overview-list__row">
                                    <span>Celková výška mojich darov</span>
                                    <strong>{{ formatCurrency(totalMyActiveInvestment) }}</strong>
                                </div>
                                <div class="overview-list__row">
                                    <span>Počet mojich darov</span>
                                    <strong>{{ totalMyActiveInvestmentCount }}</strong>
                                </div>
                                <!-- <div class="overview-list__row">
                                    <span>Skutočná výplata mojich investícií</span>
                                    <strong>{{ formatCurrency(actualMyPayout) }}</strong>
                                </div>
                                <div class="overview-list__row overview-list__row--highlight">
                                    <span>Projektovaná výplata mojich investícií</span>
                                    <strong>{{ formatCurrency(totalMyAnnualPayout) }}</strong>
                                </div> -->
                            </div>
                        </v-card>
                    </v-col>

                    <v-col cols="12" lg="7">
                        <v-card class="overview-card overview-card--projection" elevation="0">
                            <!-- <div class="projection-summary">
                                <span class="projection-summary__label">Moja projekcia predpokladanej tržby</span>
                                <strong class="projection-summary__value">{{ formatCurrency(modeledAnnualRevenue, 0)
                                    }}</strong>
                            </div>
                            <div class="projection-notes">
                                <v-chip small color="#e8edff" text-color="#26386e">
                                    Nárok: {{ formatCurrency(totalMyPayoutClaim) }}
                                </v-chip>
                                <v-chip small color="#edf4ff" text-color="#234876">
                                    Očakávaný ročný výnos: {{ portfolioRoi }}
                                </v-chip>
                                <v-chip small color="#eef8ee" text-color="#256039">
                                    Výplata z tržieb: {{ modeledPayoutPercentage }} %
                                </v-chip>
                            </div>
                            <p class="projection-text">
                                Projekcia vychádza z výšky vašich investícií a z predpokladaných tržieb.
                                Predvolená hodnota tržieb je {{ formatCurrency(defaultAnnualRevenue, 0) }}.
                            </p> -->
                            <div class="projection-related">
                                <div class="projection-related__item">
                                    <span>Spolu darované všetkými darcami</span>
                                    <strong>{{ formatCurrency(totalInvestments) }}</strong>
                                </div>
                                <!-- <div class="projection-related__item">
                                    <span>Aktuálne vyplatené investorom</span>
                                    <strong>{{ formatCurrency(actualPayouts) }}</strong>
                                </div> -->
                                <div class="projection-related__item">
                                    <span>Počet darcov</span>
                                    <strong>{{ uniqueInvestors }}</strong>
                                </div>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
            </section>

            <!-- <section class="dashboard-payback">
                <v-card class="payback-card" elevation="0">
                    <div class="payback-card__label">Predpokladaná doba návratnosti všetkých mojich investícií</div>
                    <div class="payback-card__value">{{ projectedPaybackPeriod }}</div>
                    <p class="payback-card__text">
                        Výpočet zohľadňuje celkovú výšku vašich investícií a aktuálne predpokladané tržby
                        ({{ formatCurrency(modeledAnnualRevenue, 0) }}).
                    </p>
                    <div v-if="totalMyInvestmentCount === 0" class="payback-card__empty-note">
                        Momentálne nemáte žiadnu aktívnu investíciu. V kalkulačke môžete hneď pracovať s predvolenými
                        tržbami.
                    </div>
                </v-card>
            </section> -->

            <section class="dashboard-actions">
                <!-- <div class="dashboard-actions__left action-note">
                    <div class="action-note__title">Chcete hneď vidieť detailné zmluvy a vývoj investícií?</div>
                    <div class="action-note__text">
                        Môžete pokračovať do detailu portfólia alebo najprv upraviť vstupné hodnoty v kalkulačke.
                    </div>
                </div> -->
                <div class="dashboard-actions__right">
                    <v-btn outlined color="primary" class="dashboard-actions__button" large
                        @click="scrollToSection('portfolioSection')">
                        Vstúpiť do detailnej časti mojich darov
                        <v-icon right>mdi-arrow-right</v-icon>
                    </v-btn>
                    <v-btn color="primary" class="dashboard-actions__button" large @click="scrollToCalculator">
                        Nastaviť dar
                    </v-btn>
                </div>
            </section>

            <section ref="calculatorSection" class="content-section">
                <div class="content-section__header">
                    <div>
                        <!-- <div class="section-eyebrow">Kalkulácia</div> -->
                        <h2 class="content-section__title">Nastavenie nového daru</h2>
                    </div>
                </div>
                <investment-calculator ref="calculator" :defaultAnnualRevenue="defaultAnnualRevenue"
                    :totalInvestments="totalInvestments" :maxInvestmentAmount="maxInvestmentAmount"
                    :myInactiveInvestmentsTotal="myInactiveInvestmentsTotal"
                    :activeInvestmentsTotal="activeInvestmentsTotal" :defaultPayoutPercentage="modeledPayoutPercentage"
                    :totalPayoutClaim="totalPayoutClaim"
                    @invest="handleInvestmentSubmission" @annual-revenue-change="handleAnnualRevenueChange"
                    @payout-percentage-change="handlePayoutPercentageChange"
                    @show-contract-preview="showContractPreview" />
            </section>

            <section ref="portfolioSection" class="content-section">
                <div class="content-section__header">
                    <div>
                        <div class="section-eyebrow">Detail portfólia</div>
                        <h2 class="content-section__title">Moje dary</h2>
                    </div>
                </div>
                <personal-investments-table v-if="isAuthenticated" :investments="userInvestments"
                    :annualRevenue="modeledAnnualRevenue" :totalInvestments="totalInvestments"
                    :paid-investments-total="activeInvestmentsTotalDisplay" :payoutPercentage="modeledPayoutPercentage"
                    :current-user="userInfo" :is-staff="isStaff" :deleting-investment-ids="deletingInvestmentIds"
                    :loading="loadingUserInvestments" @start-investing="scrollToCalculator"
                    @refresh="loadUserInvestments" @show-contract="showContractDetail"
                    @download-contract="downloadContract" @invest-additional="handleAdditionalInvestment"
                    @delete-investment="handleDeleteInvestment" />

                <v-card v-else class="empty-portfolio-card" elevation="0">
                    <div class="empty-portfolio-card__title">Pre detail portfólia sa musíte prihlásiť</div>
                    <div class="empty-portfolio-card__text">
                        Po prihlásení uvidíte vlastné dary, zmluvy a platobné údaje na jednom mieste.
                    </div>
                    <div class="empty-portfolio-card__actions">
                        <v-btn color="primary" @click="redirectToLogin">Prihlásenie</v-btn>
                        <v-btn outlined color="primary" @click="redirectToRegister">Registrácia</v-btn>
                    </div>
                </v-card>
            </section>

            <section class="content-section">
                <div class="content-section__header">
                    <div>
                        <div class="section-eyebrow">Celkový prehľad</div>
                        <h2 class="content-section__title">Dary celkovo</h2>
                    </div>
                </div>
                <investment-overview-table :totalContracts="totalContracts" :uniqueInvestors="uniqueInvestors"
                    :totalInvestments="totalInvestments" :totalInvestmentLevels="investmentLevels"
                    :totalPayoutRequired="totalPayoutRequired" :actualPayouts="actualPayouts"
                    :maxInvestmentAmount="maxInvestmentAmount" />
            </section>

            <section class="content-section">
                <div class="content-section__header">
                    <div>
                        <div class="section-eyebrow">Model trhu</div>
                        <h2 class="content-section__title">Predpokladané tržby a projekty</h2>
                    </div>
                </div>
                <revenue-forecast-table :realRevenues="realRevenues" :projects="projects"
                    :annualRevenue="modeledAnnualRevenue" />
            </section>
        </v-container>

        <v-dialog v-model="loginDialog" max-width="560px" persistent>
            <v-card class="login-dialog-card">
                <v-card-title class="login-dialog-title">
                    <div class="login-dialog-title__content">
                        <span class="login-dialog-title__icon">
                            <v-icon color="white" size="24">mdi-heart-plus</v-icon>
                        </span>
                        <div>
                            <div class="login-dialog-title__eyebrow">Pokračovanie v dare</div>
                            <div class="login-dialog-title__text">Vyberte si, ako chcete pokračovať</div>
                        </div>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn icon color="white" @click="loginDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="login-dialog-text pa-6">
                    <div class="login-dialog-hero">
                        <div class="login-dialog-hero__copy">
                            <div class="login-dialog-hero__title">
                                Prihlásenie je potrebné len pre zmluvu a prehľad vašich darov.
                            </div>
                            <div class="login-dialog-hero__text">
                                Ak chcete mať dar uložený vo svojom profile, zobraziť zmluvu a neskôr sledovať stav
                                platby, prihláste sa alebo si vytvorte účet. Ak chcete poslať jednorazový dar bez účtu,
                                môžete pokračovať aj priamo bankovým prevodom.
                            </div>
                        </div>
                        <div v-if="plannedInvestmentAmount" class="login-dialog-hero__amount">
                            <div class="login-dialog-hero__amount-label">Zvolený dar</div>
                            <strong>{{ formatCurrency(plannedInvestmentAmount) }}</strong>
                        </div>
                    </div>

                    <div class="login-dialog-benefits">
                        <div class="login-dialog-benefits__item">
                            <v-icon small color="#3650c9">mdi-file-document-outline</v-icon>
                            <span>Náhľad zmluvy a potvrdenia v profile</span>
                        </div>
                        <div class="login-dialog-benefits__item">
                            <v-icon small color="#3650c9">mdi-view-dashboard-outline</v-icon>
                            <span>Prehľad vlastných darov a ich stav na jednom mieste</span>
                        </div>
                        <div class="login-dialog-benefits__item">
                            <v-icon small color="#3650c9">mdi-bank-transfer-out</v-icon>
                            <span>Platobné údaje pripravené priamo pre váš účet</span>
                        </div>
                    </div>

                    <v-alert type="info" outlined class="login-dialog-alert mb-4">
                        <div class="font-weight-medium mb-1">Chcete dar poslať bez registrácie?</div>
                        <div class="text-body-2">
                            To je v poriadku. Dar môžete odoslať aj bez účtu, len sa vám neuloží do osobného prehľadu.
                        </div>
                    </v-alert>

                    <div class="login-dialog-payment">
                        <div>
                            <div class="login-dialog-payment__label">Rýchly dar bez účtu</div>
                            <div class="login-dialog-payment__iban">{{ companyIban }}</div>
                            <div class="login-dialog-payment__note">
                                Poznámka pre príjemcu: {{ companyPaymentNote }}
                            </div>
                        </div>
                        <v-btn outlined color="primary" class="login-dialog-payment__button" @click="continueWithoutAccount">
                            Pokračovať bez účtu
                        </v-btn>
                    </div>
                </v-card-text>
                <v-card-actions class="login-dialog-actions px-6 pb-6">
                    <v-btn color="grey darken-1" text @click="loginDialog = false">Teraz nie</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn outlined color="primary" @click="redirectToRegister">Registrácia</v-btn>
                    <v-btn color="primary" @click="redirectToLogin">Prihlásiť sa</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <contract-preview-dialog v-model="contractDialog" :investmentAmount="plannedInvestmentAmount"
            :userInfo="userInfo" :investmentBreakdown="contractBreakdown" @confirm="confirmInvestment" />

        <payment-details-dialog v-model="paymentDetailsDialog" :amount="plannedInvestmentAmount"
            :variable-symbol="paymentVariableSymbol" />
        <v-dialog v-model="successDialog" max-width="500px" persistent>
            <v-card>
                <v-card-title class="success white--text">
                    <v-icon left color="white">mdi-check-circle</v-icon>
                    Dar vytvorený
                </v-card-title>
                <v-card-text class="pa-6">
                    <div class="text-center">
                        <v-icon size="80" color="success" class="mb-4">mdi-check-circle-outline</v-icon>
                        <div class="text-h6 mb-2">Úspešne ste vytvorili dar</div>
                        <div class="text-body-1 mb-4">
                            Dar vo výške <strong>{{ formatCurrency(plannedInvestmentAmount) }}</strong>
                            bol úspešne vytvorený.
                        </div>
                        <v-alert type="warning" outlined class="mb-4">
                            <strong>Nezabudnite uhradiť dar.</strong><br>
                            Použite platobne údaje z náhľadu zmluvy. Dar sa zobrazí nižšie po pripisaní sumy.
                        </v-alert>
                        <div class="mb-4">
                            <div class="text-caption mb-1">Vaše darovacie ID (variabilný symbol)</div>
                            <v-chip color="primary" large>{{ userInfo.id }}</v-chip>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions class="px-6 pb-6">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" large @click="onSuccessContinue">Pokračovať</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="deleteDialog" max-width="500px">
            <v-card>
                <v-card-title class="text-h6">Potvrdenie vymazania</v-card-title>
                <v-card-text>
                    Naozaj chcete vymazať dar
                    <strong v-if="deleteInvestmentTarget && deleteInvestmentTarget.contract_number">
                        #{{ deleteInvestmentTarget.contract_number }}
                    </strong>
                    <strong v-else-if="deleteInvestmentTarget">
                        #{{ deleteInvestmentTarget.id }}
                    </strong>
                    ? Táto akcia sa nedá zvrátiť.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="closeDeleteDialog">Zrušiť</v-btn>
                    <v-btn color="error" :loading="isDeleteDialogLoading" @click="confirmDeleteInvestment">
                        Vymazať
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="6000">
            {{ snackbar.message }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar.show = false">Zavrieť</v-btn>
            </template>
        </v-snackbar>

        <v-overlay :value="loading">
            <div class="text-center">
                <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
                <div class="text-h6 mt-4">Spracováva sa...</div>
            </div>
        </v-overlay>
    </div>
</template>

<script>
import InvestmentCalculator from '@/components/invest/InvestmentCalculator.vue';
import PersonalInvestmentsTable from '@/components/invest/PersonalInvestmentsTable.vue';
import InvestmentOverviewTable from '@/components/invest/InvestmentOverviewTable.vue';
import RevenueForecastTable from '@/components/invest/RevenueForecastTable.vue';
import ContractPreviewDialog from '@/components/invest/ContractPreviewDialog.vue';
import PaymentDetailsDialog from '@/components/invest/PaymentDetailsDialog.vue';
import { APIService } from "@/http/APIService.js";
import { mapGetters } from "vuex";
import { formatCurrency } from "@/utils/investment-math";
import {
    COMPANY,
    DEFAULT_ANNUAL_REVENUE,
    DEFAULT_PAYOUT_PERCENTAGE,
    INVESTMENT_CAPACITY,
    INVESTMENT_LEVEL_TABLE,
    TOTAL_PAYOUT_REQUIRED
} from "@/config/investment";

const apiService = new APIService();

export default {
    name: "InvestmentPlatform",

    components: {
        InvestmentCalculator,
        PersonalInvestmentsTable,
        InvestmentOverviewTable,
        RevenueForecastTable,
        ContractPreviewDialog,
        PaymentDetailsDialog
    },

    data() {
        return {
            loading: false,
            loadingUserInvestments: false,
            loginDialog: false,
            contractDialog: false,
            successDialog: false,
            plannedInvestmentAmount: 0,
            contractBreakdown: [],
            paymentDetailsDialog: false,
            isGuestPaymentFlow: false,
            realRevenues: [],
            defaultAnnualRevenue: DEFAULT_ANNUAL_REVENUE,
            modeledAnnualRevenue: DEFAULT_ANNUAL_REVENUE,
            modeledPayoutPercentage: DEFAULT_PAYOUT_PERCENTAGE,
            totalInvestments: 0,
            activeInvestmentsTotal: null,
            maxInvestmentAmount: INVESTMENT_CAPACITY,
            uniqueInvestors: 0,
            totalContracts: 0,
            investmentLevels: INVESTMENT_LEVEL_TABLE.map(l => ({ ...l })),
            totalPayoutRequired: TOTAL_PAYOUT_REQUIRED,
            totalPayoutClaim: 0,
            actualPayouts: 0,
            projects: [],
            deletingInvestmentIds: [],
            deleteDialog: false,
            isDeleteDialogLoading: false,
            deleteInvestmentTarget: null,
            snackbar: {
                show: false,
                message: '',
                color: 'success'
            },
            userInvestments: [],
            userInfo: {
                id: 123,
                first_name: 'Demo',
                last_name: 'Investor',
                email: 'demo@example.com',
                address: 'Demo adresa'
            }
        };
    },

    computed: {
        ...mapGetters("auth", [
            "isAuthenticated",
            "username",
            "isVerified",
            "isVerifiedSmsEmail",
            "isVerifiedBank",
            "isStaff",
            "getMemberStatus",
            "firstName",
            "lastName",
            "gender"
        ]),

        investorDisplayName() {
            const user = this.userInfo || {};
            const fullName = [user.first_name, user.last_name].filter(Boolean).join(' ').trim();
            return fullName || this.username || 'Investor';
        },

        headerImageSrc() {
            try {
                return require('@/assets/invest/family-bread.png');
            } catch {
                return require('@/assets/nase_hnutie.png');
            }
        },

        companyIban() {
            return COMPANY.iban;
        },

        companyPaymentNote() {
            return COMPANY.paymentNote;
        },

        paymentVariableSymbol() {
            if (this.isGuestPaymentFlow || !this.isAuthenticated) {
                return null;
            }
            return this.userInfo && this.userInfo.id ? this.userInfo.id : null;
        },

        myInactiveInvestmentsTotal() {
            return this.userInvestments.reduce((sum, investment) => {
                const isActive = this.isInvestmentActive(investment);
                if (isActive) return sum;
                const amount = this.parseNumericValue(investment.investment_amount);
                return sum + (Number.isFinite(amount) ? amount : 0);
            }, 0);
        },

        totalMyInvestment() {
            return this.userInvestments.reduce((sum, investment) => {
                const amount = this.parseNumericValue(investment.investment_amount);
                return sum + (Number.isFinite(amount) ? amount : 0);
            }, 0);
        },

        totalMyActiveInvestment() {
            return this.userInvestments.reduce((sum, investment) => {
                if (!this.isInvestmentActive(investment)) {
                    return sum;
                }

                const amount = this.parseNumericValue(investment.investment_amount);
                return sum + (Number.isFinite(amount) ? amount : 0);
            }, 0);
        },

        totalMyPaidInvestment() {
            return this.userInvestments.reduce((sum, investment) => {
                if (!this.isInvestmentPaid(investment)) {
                    return sum;
                }

                const amount = this.parseNumericValue(investment.investment_amount);
                return sum + (Number.isFinite(amount) ? amount : 0);
            }, 0);
        },

        totalMyInvestmentCount() {
            return this.userInvestments.length;
        },

        totalMyActiveInvestmentCount() {
            return this.userInvestments.reduce((count, investment) => {
                return this.isInvestmentActive(investment) ? count + 1 : count;
            }, 0);
        },

        totalMyPayoutClaim() {
            return this.userInvestments.reduce((sum, investment) => {
                const amount = this.parseNumericValue(investment.payout_claim);
                return sum + (Number.isFinite(amount) ? amount : 0);
            }, 0);
        },

        effectivePayoutBaseInvestments() {
            const paidTotal = this.parseNumericValue(this.activeInvestmentsTotal);
            if (paidTotal > 0) {
                return paidTotal;
            }

            const total = this.parseNumericValue(this.totalInvestments);
            return total > 0 ? total : 0;
        },

        totalMyAnnualPayout() {
            const totalAllInvestments = this.effectivePayoutBaseInvestments;
            if (!Number.isFinite(totalAllInvestments) || totalAllInvestments <= 0) {
                return 0;
            }

            const modeledRevenue = this.parseNumericValue(this.modeledAnnualRevenue);
            const revenueForPayouts = modeledRevenue * (this.modeledPayoutPercentage / 100);

            return this.userInvestments.reduce((sum, investment) => {
                if (!this.isInvestmentPaid(investment)) {
                    return sum;
                }

                const investmentAmount = this.parseNumericValue(investment.investment_amount);
                if (investmentAmount <= 0) {
                    return sum;
                }

                const rawAnnualPayout = revenueForPayouts * (investmentAmount / totalAllInvestments);
                const payoutClaim = this.parseNumericValue(investment.payout_claim);
                const clampedAnnualPayout = payoutClaim > 0 ? Math.min(rawAnnualPayout, payoutClaim) : rawAnnualPayout;
                return sum + clampedAnnualPayout;
            }, 0);
        },

        actualMyPayout() {
            const candidateFields = ['actual_payout', 'actual_paid', 'paid_out_amount', 'payout_paid', 'paid_amount'];
            return this.userInvestments.reduce((sum, investment) => {
                const value = candidateFields.reduce((found, field) => {
                    if (found != null) return found;
                    return investment[field] != null ? investment[field] : null;
                }, null);
                const amount = Number(value);
                return sum + (Number.isFinite(amount) ? amount : 0);
            }, 0);
        },

        projectedPaybackPeriod() {
            if (this.totalMyInvestment <= 0) return 'Zatiaľ bez daru';
            if (this.totalMyAnnualPayout <= 0) return 'Nedá sa vypočítať';
            const years = this.totalMyInvestment / this.totalMyAnnualPayout;
            if (years >= 10) return '10+ rokov';
            if (years >= 1) return `${years.toFixed(1)} roka`;
            return `${Math.ceil(years * 12)} mesiacov`;
        },
        portfolioParticipationPercentage() {
            const totalAllPaidInvestments = this.effectivePayoutBaseInvestments;
            if (!totalAllPaidInvestments) return '0.0000';
            return ((this.totalMyPaidInvestment / totalAllPaidInvestments) * 100).toFixed(4);
        },

        portfolioRoi() {
            if (!this.totalMyInvestment) return '0 %';
            return `${((this.totalMyAnnualPayout / this.totalMyInvestment) * 100).toFixed(1)} %`;
        },

        activeInvestmentsTotalDisplay() {
            return this.effectivePayoutBaseInvestments;
        },

        portfolioHealthChip() {
            if (this.totalMyInvestmentCount === 0) {
                return { label: 'Bez daru', color: 'grey darken-1' };
            }
            if (this.myInactiveInvestmentsTotal > 0) {
                return { label: 'Čaká na úhradu', color: 'warning darken-2' };
            }
            return { label: 'Aktívne portfólio', color: 'success darken-1' };
        }
    },

    watch: {
        isAuthenticated: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.loadUserInvestments();
                    this.loadUserInfo();
                }
            }
        }
    },

    mounted() {
        this.loadInitialData();
    },

    methods: {
        loadInitialData() {
            this.loading = true;
            Promise.all([
                apiService.getInvestmentStats(),
                apiService.getRevenueForecast(),
                apiService.getInvestmentProjects(),
                apiService.getInvestmentRevenues()
            ]).then(([statsResponse, revenueResponse, projectsResponse, revenueListResponse]) => {
                if (statsResponse) {
                    this.totalInvestments = statsResponse.totalInvestments;
                    this.activeInvestmentsTotal =
                        Number.isFinite(Number(statsResponse.totalActiveInvestments))
                            ? Number(statsResponse.totalActiveInvestments)
                            : Number.isFinite(Number(statsResponse.activeInvestments))
                                ? Number(statsResponse.activeInvestments)
                                : Number.isFinite(Number(statsResponse.active_total_investments))
                                    ? Number(statsResponse.active_total_investments)
                                    : null;
                    this.totalPayoutClaim = statsResponse.totalPayoutClaim || 0;
                    this.actualPayouts = statsResponse.actualPayouts || 0;
                    this.uniqueInvestors = statsResponse.uniqueInvestors;
                    this.totalContracts = statsResponse.totalContracts;
                }
                if (revenueResponse) {
                    this.modeledAnnualRevenue = this.defaultAnnualRevenue;
                }
                if (projectsResponse) {
                    this.projects = projectsResponse.results;
                }
                if (revenueListResponse) {
                    this.realRevenues = revenueListResponse.results;
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },

        loadUserInvestments() {
            this.loadingUserInvestments = true;
            apiService.getUserInvestments().then((response) => {
                this.userInvestments = (response && response.results) ? response.results
                    : Array.isArray(response) ? response : [];
                this.loadingUserInvestments = false;
            }).catch((err) => {
                console.error('loadUserInvestments error:', err);
                this.loadingUserInvestments = false;
            });
        },

        loadUserInfo() {
            apiService.getMe().then((response) => {
                this.userInfo = response;
            });
        },

        handleInvestmentSubmission(amount) {
            this.plannedInvestmentAmount = amount;
            if (!this.isAuthenticated) {
                this.loginDialog = true;
                return;
            }
            this.loading = true;
            apiService.createInvestment({ investment_amount: amount }).then(() => {
                this.successDialog = true;
                this.loadUserInvestments();
                this.loadInitialData();
            }).catch((error) => {
                console.error('Chyba pri vytváraní daru:', error);
                const statusCode = error && error.response ? error.response.status : null;
                if (statusCode === 401) {
                    this.showSnackbar('Relácia vypršala. Prihláste sa znova.', 'error');
                } else {
                    this.showSnackbar('Dar sa nepodarilo vytvoriť. Skúste to znova.', 'error');
                }
            }).finally(() => {
                this.loading = false;
            });
        },

        handleAdditionalInvestment(amount) {
            this.handleInvestmentSubmission(amount);
        },

        handleDeleteInvestment(investment) {
            if (!investment || !investment.id) return;
            this.deleteInvestmentTarget = investment;
            this.deleteDialog = true;
        },

        closeDeleteDialog() {
            this.deleteDialog = false;
            this.$nextTick(() => {
                this.deleteInvestmentTarget = null;
            });
        },

        showSnackbar(message, color = 'success') {
            this.snackbar.message = message;
            this.snackbar.color = color;
            this.snackbar.show = true;
        },

        confirmDeleteInvestment() {
            const investment = this.deleteInvestmentTarget;
            if (!investment || !investment.id) {
                this.closeDeleteDialog();
                return;
            }
            const investmentLabel = investment.contract_number ? `#${investment.contract_number}` : `#${investment.id}`;
            this.isDeleteDialogLoading = true;
            if (!this.deletingInvestmentIds.includes(investment.id)) {
                this.deletingInvestmentIds.push(investment.id);
            }
            apiService.deleteInvestment(investment.id).then(() => {
                this.userInvestments = this.userInvestments.filter(item => item.id !== investment.id);
                this.loadUserInvestments();
                this.loadInitialData();
                this.showSnackbar(`Dar ${investmentLabel} bol úspešne vymazaný.`, 'success');
                this.closeDeleteDialog();
            }).catch((error) => {
                const statusCode = error && error.response ? error.response.status : null;
                if (statusCode === 403) {
                    this.showSnackbar('Aktívny dar nie je možné vymazať. Kontaktujte administrátora.', 'error');
                    this.closeDeleteDialog();
                    return;
                }
                if (statusCode === 404) {
                    this.loadUserInvestments();
                    this.showSnackbar('Dar nebol nájdený. Zoznam bol obnovený.', 'warning');
                    this.closeDeleteDialog();
                    return;
                }
                if (statusCode === 401) {
                    this.showSnackbar('Relácia vypršala. Prihláste sa znova.', 'error');
                    this.closeDeleteDialog();
                    return;
                }
                this.showSnackbar('Dar sa nepodarilo vymazať. Skúste to znova.', 'error');
            }).finally(() => {
                this.deletingInvestmentIds = this.deletingInvestmentIds.filter(id => id !== investment.id);
                this.isDeleteDialogLoading = false;
            });
        },

        showContractPreview(data) {
            this.plannedInvestmentAmount = data && data.amount ? data.amount : 0;
            if (!this.isAuthenticated) {
                this.loginDialog = true;
                return;
            }
            this.contractBreakdown = data.breakdown || [];
            this.contractDialog = true;
        },

        onSuccessContinue() {
            this.isGuestPaymentFlow = false;
            this.successDialog = false;
            this.paymentDetailsDialog = true;
        },

        confirmInvestment(investmentData) {
            this.loading = true;
            apiService.createInvestment(investmentData).then(() => {
                this.contractDialog = false;
                this.successDialog = true;
                this.loadUserInvestments();
                this.loadInitialData();
            }).catch((error) => {
                console.error('Chyba pri vytváraní daru:', error);
                const statusCode = error && error.response ? error.response.status : null;
                if (statusCode === 401) {
                    this.showSnackbar('Relácia vypršala. Prihláste sa znova.', 'error');
                } else {
                    this.showSnackbar('Dar sa nepodarilo vytvoriť. Skúste to znova.', 'error');
                }
            }).finally(() => {
                this.loading = false;
            });
        },

        handleAnnualRevenueChange(newRevenue) {
            this.modeledAnnualRevenue = newRevenue;
        },

        handlePayoutPercentageChange(newPercentage) {
            const parsed = Number(newPercentage);
            if (Number.isFinite(parsed)) {
                this.modeledPayoutPercentage = parsed;
            }
        },

        scrollToCalculator() {
            this.scrollToSection('calculatorSection');
        },

        scrollToSection(refName) {
            const target = this.$refs[refName];
            const element = target && target.$el ? target.$el : target;
            if (element && element.scrollIntoView) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        },

        showContractDetail(investment) {
            console.log('Show contract detail:', investment);
        },

        downloadContract(investment) {
            console.log('Download contract:', investment);
        },

        redirectToLogin() {
            this.loginDialog = false;
            this.$router.push('/login');
        },

        redirectToRegister() {
            this.loginDialog = false;
            this.$router.push('/register');
        },

        continueWithoutAccount() {
            this.isGuestPaymentFlow = true;
            this.loginDialog = false;
            this.paymentDetailsDialog = true;
        },

        parseNumericValue(value) {
            if (typeof value === 'number') {
                return Number.isFinite(value) ? value : 0;
            }

            if (typeof value === 'string') {
                const normalized = value
                    .replace(/\s/g, '')
                    .replace('€', '')
                    .replace(',', '.');
                const parsed = Number(normalized);
                return Number.isFinite(parsed) ? parsed : 0;
            }

            const parsed = Number(value);
            return Number.isFinite(parsed) ? parsed : 0;
        },

        isInvestmentActive(investment) {
            const status = investment && investment.status;
            return status === true || status === 1 || status === '1' || status === 'true';
        },

        isInvestmentPaid(investment) {
            const status = String(investment && investment.status || '').toLowerCase();
            const paidStatus = status === 'completed' || status === 'active' || status === 'paid';
            return this.isInvestmentActive(investment) || paidStatus || !!(investment && investment.payment_date);
        },

        formatCurrency
    }
};
</script>

<style scoped>
.investment-platform {
    min-height: 100vh;
    background:
        radial-gradient(circle at top left, rgba(115, 130, 255, 0.18), transparent 32%),
        radial-gradient(circle at top right, rgba(135, 71, 195, 0.16), transparent 28%),
        linear-gradient(180deg, #eef3fb 0%, #f8fafc 45%, #edf2f9 100%);
}

.investment-container {
    max-width: 1480px;
    padding: 24px 20px 72px;
}

.section-eyebrow,
.dashboard-header__meta-title {
    margin-bottom: 10px;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    opacity: 0.78;
}

.dashboard-header,
.dashboard-overview,
.dashboard-payback,
.dashboard-actions,
.content-section {
    margin-bottom: 28px;
}

.dashboard-header {
    display: grid;
    grid-template-columns: minmax(0, 2fr) minmax(320px, 1fr);
    gap: 24px;
    padding: 28px;
    border-radius: 20px;
    color: #fff;
    background: linear-gradient(120deg, #5b79f7 0%, #7058cd 45%, #7b4cb8 100%);
    box-shadow: 0 22px 50px rgba(54, 66, 146, 0.22);
}

.dashboard-header__title-group {
    display: grid;
    gap: 18px;
    align-content: center;
}

.dashboard-header__title {
    display: flex;
    align-items: center;
    gap: 16px;
    font-size: clamp(1.8rem, 3.2vw, 3.5rem);
    line-height: 1.06;
    font-weight: 800;
    letter-spacing: -0.02em;
}

.dashboard-header__title-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    border-radius: 999px;
    border: 2px solid rgba(255, 255, 255, 0.9);
    background: rgba(255, 255, 255, 0.08);
    flex-shrink: 0;
}

.dashboard-header__hero-image-wrap {
    max-width: 640px;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 16px 30px rgba(20, 28, 70, 0.25);
    border: 1px solid rgba(255, 255, 255, 0.28);
}

.dashboard-header__hero-image {
    display: block;
    width: 100%;
    max-height: 260px;
    object-fit: cover;
    object-position: center;
}

.dashboard-header__meta {
    padding: 16px 18px;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.14);
    border: 1px solid rgba(255, 255, 255, 0.18);
    backdrop-filter: blur(12px);
}

.dashboard-header__meta-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 8px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.16);
}

.dashboard-header__meta-row:last-child {
    border-bottom: 0;
}

.dashboard-header__meta-row span {
    color: rgba(255, 255, 255, 0.8);
}

.dashboard-header__meta-row strong {
    font-size: 0.95rem;
}

.overview-card {
    height: 100%;
    padding: 24px;
    border-radius: 20px;
    box-shadow: 0 14px 36px rgba(22, 33, 61, 0.08);
}

.overview-card--investments {
    background: #ffffff;
}

.overview-card--projection {
    background: linear-gradient(180deg, #ffffff 0%, #f5f8ff 100%);
}

.overview-card__title {
    display: flex;
    align-items: center;
    margin-bottom: 18px;
    color: #2643af;
    font-size: 2rem;
    font-weight: 800;
    line-height: 1.1;
}

.overview-list {
    display: grid;
    gap: 10px;
}

.overview-list__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 0;
    border-bottom: 1px solid #e8eefb;
    font-size: 1.08rem;
    color: #22304f;
}

.overview-list__row:last-child {
    border-bottom: 0;
}

.overview-list__row strong {
    font-size: 1.25rem;
    color: #ca2e2e;
}

.overview-list__row--highlight {
    padding: 16px;
    border-radius: 14px;
    border-bottom: 0;
    background: #f2f6ff;
}

.projection-summary {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;
}

.projection-summary__label {
    font-size: clamp(1.25rem, 2vw, 2.1rem);
    font-weight: 800;
    color: #cb2d2d;
}

.projection-summary__value {
    font-size: clamp(1.6rem, 3vw, 3rem);
    letter-spacing: -0.02em;
    color: #c11f1f;
    line-height: 1;
    text-align: right;
    white-space: nowrap;
    flex-shrink: 0;
}

.projection-notes {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 14px;
}

.projection-text {
    margin: 0;
    color: #355074;
    line-height: 1.65;
}

.projection-related {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
    margin-top: 16px;
}

.projection-related__item {
    padding: 12px;
    border-radius: 12px;
    border: 1px solid #d8e4ff;
    background: #ffffff;
}

.projection-related__item span {
    display: block;
    color: rgba(25, 52, 92, 0.68);
    font-size: 0.78rem;
}

.projection-related__item strong {
    display: block;
    margin-top: 8px;
    font-size: 1rem;
    color: #1d3c93;
}

.payback-card {
    padding: 24px 26px;
    border-radius: 20px;
    background: linear-gradient(180deg, #ffffff 0%, #f6f8ff 100%);
    box-shadow: 0 14px 36px rgba(22, 33, 61, 0.08);
}

.payback-card__label {
    font-size: clamp(1.2rem, 2.3vw, 2rem);
    font-weight: 800;
    color: #c72f2f;
}

.payback-card__value {
    margin: 10px 0 8px;
    font-size: clamp(1.7rem, 3vw, 2.8rem);
    font-weight: 800;
    color: #1b2d61;
}

.payback-card__text {
    margin: 0;
    color: rgba(24, 39, 78, 0.72);
    line-height: 1.65;
}

.payback-card__empty-note {
    margin-top: 16px;
    padding: 14px 16px;
    border-radius: 12px;
    border: 1px solid #ffe0b6;
    background: #fff8ed;
    color: #8f5416;
}

.dashboard-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
}

.dashboard-actions__button {
    min-height: 48px;
    border-radius: 12px;
    text-transform: none;
    letter-spacing: 0;
    font-weight: 700;
}

.dashboard-actions__right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 12px;
    margin-left: auto;
    min-width: 360px;
}

.action-note {
    padding: 18px 20px;
    border-radius: 16px;
    background: linear-gradient(180deg, #ffffff 0%, #f4f8ff 100%);
    border: 1px solid #e1eaff;
}

.action-note__title {
    font-size: clamp(1.05rem, 1.6vw, 1.4rem);
    font-weight: 800;
    color: #cc2b2b;
}

.action-note__text {
    margin-top: 8px;
    color: rgba(19, 40, 82, 0.72);
    line-height: 1.6;
}

.section-eyebrow {
    color: rgba(17, 32, 70, 0.66);
}

.content-section__header {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 20px;
    margin-bottom: 16px;
}

.content-section__title {
    margin: 0;
    font-size: clamp(1.55rem, 2vw, 2rem);
    line-height: 1.1;
    letter-spacing: -0.03em;
    color: #16213d;
}

.empty-portfolio-card {
    padding: 28px;
    border-radius: 24px;
    background: linear-gradient(180deg, #ffffff 0%, #f4f7fc 100%);
    box-shadow: 0 16px 40px rgba(21, 34, 71, 0.08);
}

.empty-portfolio-card__title {
    margin-bottom: 10px;
    font-size: 1.35rem;
    font-weight: 800;
    color: #16213d;
}

.empty-portfolio-card__text {
    max-width: 680px;
    color: rgba(22, 33, 61, 0.72);
    line-height: 1.65;
}

.empty-portfolio-card__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 22px;
}

@media (max-width: 960px) {
    .investment-container {
        padding: 16px 12px 56px;
    }

    .dashboard-header,
    .overview-card,
    .payback-card,
    .empty-portfolio-card {
        border-radius: 22px;
    }

    .dashboard-header {
        grid-template-columns: 1fr;
        padding: 24px;
    }

    .dashboard-header__hero-image-wrap {
        max-width: none;
    }

    .dashboard-actions {
        flex-direction: column;
        align-items: stretch;
    }

    .projection-related {
        grid-template-columns: 1fr;
    }

    .dashboard-actions__left,
    .dashboard-actions__right {
        width: 100%;
    }

    .dashboard-actions__right {
        margin-left: 0;
        min-width: 0;
    }

    .dashboard-actions__button {
        width: 100%;
    }
}

@media (max-width: 600px) {
    .empty-portfolio-card__actions {
        flex-direction: column;
    }

    .projection-summary__value {
        font-size: clamp(1.35rem, 7.2vw, 2.1rem);
    }

    .dashboard-header__meta-row,
    .overview-list__row,
    .projection-summary {
        flex-direction: column;
        align-items: flex-start;
    }

    .dashboard-header,
    .overview-card,
    .payback-card {
        padding: 20px;
    }

    .dashboard-header__title-icon {
        width: 52px;
        height: 52px;
    }

    .dashboard-header__hero-image {
        max-height: 220px;
    }
}

.login-dialog-card {
    border-radius: 24px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(22, 33, 61, 0.16);
}

.login-dialog-title {
    padding: 20px 24px;
    color: #fff;
    background: linear-gradient(135deg, #3650c9 0%, #243a9b 100%);
}

.login-dialog-title__content {
    display: flex;
    align-items: center;
    gap: 14px;
}

.login-dialog-title__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.16);
    border: 1px solid rgba(255, 255, 255, 0.24);
}

.login-dialog-title__eyebrow {
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    opacity: 0.78;
}

.login-dialog-title__text {
    margin-top: 2px;
    font-size: 1.18rem;
    font-weight: 800;
    letter-spacing: -0.02em;
}

.login-dialog-text {
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.login-dialog-hero {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;
}

.login-dialog-hero__copy {
    flex: 1 1 auto;
}

.login-dialog-hero__title {
    color: #16213d;
    font-size: 1.2rem;
    font-weight: 800;
    line-height: 1.3;
}

.login-dialog-hero__text {
    margin-top: 10px;
    color: rgba(22, 33, 61, 0.72);
    line-height: 1.65;
}

.login-dialog-hero__amount {
    min-width: 150px;
    padding: 14px 16px;
    border-radius: 18px;
    background: linear-gradient(180deg, #edf3ff 0%, #ffffff 100%);
    border: 1px solid #dbe6ff;
    text-align: right;
}

.login-dialog-hero__amount-label {
    font-size: 0.78rem;
    color: rgba(17, 32, 70, 0.58);
}

.login-dialog-hero__amount strong {
    display: block;
    margin-top: 6px;
    font-size: 1.28rem;
    color: #2442ab;
}

.login-dialog-benefits {
    display: grid;
    gap: 10px;
    margin-bottom: 20px;
}

.login-dialog-benefits__item {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 12px 14px;
    border-radius: 14px;
    background: #f5f8ff;
    color: #213354;
}

.login-dialog-alert {
    margin-bottom: 20px !important;
}

.login-dialog-payment {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 16px 18px;
    border-radius: 18px;
    border: 1px solid #d7e2fb;
    background: #ffffff;
}

.login-dialog-payment__label {
    font-size: 0.82rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(17, 32, 70, 0.52);
}

.login-dialog-payment__iban {
    margin-top: 6px;
    font-size: 1.18rem;
    font-weight: 800;
    color: #2442ab;
}

.login-dialog-payment__note {
    margin-top: 6px;
    color: rgba(22, 33, 61, 0.7);
    line-height: 1.5;
}

.login-dialog-payment__button {
    flex-shrink: 0;
}

.login-dialog-actions {
    padding-top: 0;
}

@media (max-width: 600px) {
    .login-dialog-title {
        padding: 18px 18px 16px;
    }

    .login-dialog-hero,
    .login-dialog-payment {
        flex-direction: column;
    }

    .login-dialog-hero__amount,
    .login-dialog-payment__button {
        width: 100%;
        text-align: left;
    }
}
</style>
